export default __webpack_public_path__ + "static/media/Magadhi_agri_m.403c109c.wav";